import {takeLeading, put, takeLatest} from 'redux-saga/effects';
import {actions} from 'reducer/appSlice';
import  NetworkHandler from 'utils/network';
import {setJson, getJson} from 'utils/storage';
import config from 'config';
import Auth from 'utils/auth';
import {actions as authActions} from 'modules/auth/slices/authSlice';

function* getResources() {
    try {
        try {
            const response = yield NetworkHandler.get(config.getUrl('service','admin'),{
                params:{
                    page:0, limit:100
                }
            }, 'v3-api');
            yield put({type: actions.get_resources_succeed.type, payload: {services:response.data}});
        } catch (error) {
            yield Auth.logout();
            yield put({type: authActions.load_user_failed.type, payload: error});
        }  
    } catch (error) {
        yield put({type: actions.get_resources_failed.type, payload: error});
    }
}

function* toggleShowAppTour({payload}) {
    yield setJson('app', {showAppTour: payload.showAppTour});
}

function* watchApp() {
    const appState = getJson('app');

    yield put({type: actions.toggle_show_app_tour.type, 
        payload: {
            showAppTour: appState ? !!appState.showAppTour : true
        }}); 

    yield takeLeading(actions.get_resources.type, getResources);
    yield takeLatest(actions.toggle_show_app_tour.type, toggleShowAppTour);
}

export default watchApp;